import PrivacyTermPDV from 'modules/terms/PrivacyTermPDV'
import React from 'react'

export default function PrivacyPoliciePDV() {
  return (
    <PrivacyTermPDV />
  )
}
